import { ReactNode, useState, useEffect } from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import { HorizontalNavigation } from "../navigation/HorizontalNavigation";
import { useAuth } from "@/hooks/auth";
import { supabase } from "@/integrations/supabase/client";
import AdminLayout from "./AdminLayout";
import { Outlet, redirect, useNavigate } from "react-router-dom";
import Testing from "./Testsing";

interface LayoutProps {
  children: ReactNode;
}

const Layout = () => {
  const { user, userProfile, loading } = useAuth();
  const navigate = useNavigate();
  // const [loading, setLoading] = useState(true);
  // const { subscriptionStatus } = useSubscriptionStatus();
  // console.log("LayoutContent rendered, user:", user, "profile:", userProfile);
  // console.log("loading:", loading);
  // التحقق من نوع المستخدم
  // const [userRole, setUserRole] = useState<string | null>(null);

  // useEffect(() => {
  //   if (userProfile) {
  //     const userRole = userProfile.role;
  //     console.log("navigate to ", userRole);
  //     if (userRole === "admin" && location.pathname !== "/admin") {
  //       navigate("/admin", { replace: true });
  //     }
  //     if (userRole === "teacher" && location.pathname !== "/attendance") {
  //       navigate("/attendance", { replace: true });
  //     }
  //     if (
  //       userRole === "student" &&
  //       location.pathname !== "/student-attendance"
  //     ) {
  //       navigate("/student-attendance", { replace: true });
  //     }
  //   }
  // }, [userProfile]);
  const loadingComponent = () => (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">جاري التحميل...</p>
      </div>
    </div>
  );

  if (loading) {
    return loadingComponent();
  }
  if (
    loading === false &&
    !userProfile &&
    window.location.pathname !== "/auth"
  ) {
    navigate("/auth");
    // return null;
  }

  // إذا لم يكن هناك مستخدم مسجل دخول، لا تعرض التنقل
  if (!userProfile || user?.user_metadata?.must_reset_password === true) {
    return (
      <div
        className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 relative overflow-hidden"
        dir="rtl"
      >
        {/* خلفية ثابتة بدون حركة */}
        <div className="absolute inset-0 bg-gradient-to-br from-background via-muted/20 to-background"></div>

        {/* Subtle dot pattern overlay */}
        <div
          className="absolute inset-0 opacity-[0.015] pointer-events-none"
          style={{
            backgroundImage: `radial-gradient(circle at 2px 2px, hsl(var(--school-navy)) 1px, transparent 0)`,
            backgroundSize: "40px 40px",
          }}
        ></div>

        {/* Gradient mesh overlay */}
        <div className="absolute inset-0 opacity-[0.02] pointer-events-none bg-gradient-to-br from-transparent via-school-green/10 to-transparent"></div>

        {/* Layout بدون تنقل للمستخدمين غير مسجلي الدخول */}
        <div className="relative min-h-screen w-full z-10">
          <div className="min-h-screen">
            <Header />
            <main className="flex-1 backdrop-blur-[0.5px] p-4">
              <div className="max-w-full">
                <Outlet />
              </div>
            </main>
            <Footer />
          </div>
        </div>
      </div>
    );
  }

  if (user && user?.user_metadata?.must_reset_password === true) {
    console.log("User must reset password, redirecting...");
    navigate("/auth/reset-password");
    //   navigate("/auth");

    // return;
  }
  // if (!user || !userProfile) {
  //   return navigate("/auth");
  // }

  // إذا كان المستخدم مدير، استخدم تخطيط المدير
  // if (
  //   userProfile?.role === "admin" &&
  //   location.pathname === "/"
  //   // (location.pathname === "/admin" || location.pathname === "/profile")
  // ) {
  //   // navigate("/admin");

  //   // return (
  //   //   <AdminLayout>
  //   //     <Outlet />
  //   //   </AdminLayout>
  //   // );
  // }

  // للمدارس: إذا كان الاشتراك منتهي أو معطل، لا تعرض التخطيط العادي
  // if (userRole === 'school' && subscriptionStatus && !subscriptionStatus.is_active) {
  //   return <>{children}</>;
  // }

  // تخطيط المدرسة العادي مع التنقل الأفقي - يظهر فقط للمستخدمين المسجلين
  return (
    <div
      className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100relative overflow-hidden"
      dir="rtl"
    >
      {/* خلفية ثابتة بدون حركة */}
      <div className="absolute inset-0 bg-gradient-to-br from-background via-muted/20 to-background"></div>

      {/* Subtle dot pattern overlay */}
      <div
        className="absolute inset-0 opacity-[0.015] pointer-events-none"
        style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, hsl(var(--school-navy)) 1px, transparent 0)`,
          backgroundSize: "40px 40px",
        }}
      ></div>

      {/* Gradient mesh overlay */}
      <div className="absolute inset-0 opacity-[0.02] pointer-events-none bg-gradient-to-br from-transparent via-school-green/10 to-transparent"></div>

      <div className="relative min-h-screen w-full z-10">
        <div className="min-h-screen">
          {/* <Header /> */}
          {/* شريط التنقل الأفقي أسفل الهيدر */}
          {/* <HorizontalNavigation />

          <main className="flex-1 backdrop-blur-[0.5px] p-4 min-h-[60vh] pb-64">
            <div className="max-w-full">{children}</div>
          </main> */}
          {/* <Testing /> */}
          {/* <HorizontalNavigation /> */}
          {location.pathname !== "/admin" && <Header />}
          <Outlet />
          <Footer />
        </div>
      </div>
    </div>
  );
};

// const Layout = ({ children }: LayoutProps) => {
//   return <LayoutContent>{children}</LayoutContent>;
// };

export default Layout;
